import { ExternalLink, Info } from 'lucide-react';
import { cx } from '@/lib/cx';
import { suiteCopy } from './copy';
import styles from './PlatformLimitNote.module.css';

export interface PlatformLimitNoteProps {
  /** Identificador estável do limite (teste e auditoria de cobertura: "bio_link", "reels_follows"…). */
  id: string;
  text: string;
  /** Página oficial da Meta que documenta o limite. */
  sourceUrl?: string;
  tone?: 'info' | 'warning';
  className?: string;
}

/**
 * "Limite da Meta" (SPEC-v2 1.3 item 4, 8.5): o que a API não permite, dito onde importa. Linha com
 * ícone `info`, texto secundário e o link "Fonte: Meta". Nunca em vermelho: limite não é erro.
 */
export function PlatformLimitNote({ id, text, sourceUrl, tone = 'info', className }: PlatformLimitNoteProps) {
  return (
    <p className={cx(styles.note, className)} data-tone={tone} data-testid={`limit-${id}`} data-limit-id={id}>
      <Info size={14} strokeWidth={1.75} aria-hidden="true" className={styles.icon} />
      <span className={styles.text}>
        <span className={styles.sr}>{suiteCopy.limit.prefix}: </span>
        {text}
        {sourceUrl && (
          <>
            {' '}
            <a
              className={styles.source}
              href={sourceUrl}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={suiteCopy.limit.sourceAria(text)}
            >
              {suiteCopy.limit.source}
              <ExternalLink size={11} strokeWidth={2} aria-hidden="true" />
            </a>
          </>
        )}
      </span>
    </p>
  );
}
